import { render, staticRenderFns } from "./Pencil.vue?vue&type=template&id=66a12230&scoped=true&"
import script from "./Pencil.vue?vue&type=script&lang=js&"
export * from "./Pencil.vue?vue&type=script&lang=js&"
import style0 from "./Pencil.vue?vue&type=style&index=0&id=66a12230&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a12230",
  null
  
)

export default component.exports